import styled, { css } from 'styled-components';

const styleMap = {
  Pedido: css`
    background-color: #daddf3;
    border: 2px solid #5062f0;
    color: #5062f0;
  `,
  Receber: css`
    background-color: #FFF2CC;
    color: #AA8208;
  `,
  Recebido: css`
    background-color: #D2F9D6;
    color: #006608;
  `,
  Devolvido: css`
    background-color: #F7D4D7;
    color: #AA0816;
  `,
  'Não recebido': css`
    background-color: #F7D56E;
    color: #AA0816;
  `
};

export const Wrapper = styled.div`
  width: 178px;
  padding: 6px 12px;
  border-radius: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  ${({ type }) => styleMap[type] || ''}
`;

export const Label = styled.span`
  font-weight: ${({ isPedido }) => (isPedido ? 'bold' : 'normal')};
`;

export const SubLabel = styled.span`
  font-size: 12px;
`;
